import Cookies from "js-cookie";

export const get = (name) => Cookies.get(name);
export const set = (name, value, options = {}) =>
	Cookies.set(name, value, options);
export const remove = (name, options = {}) => Cookies.remove(name, options);

// detect if running in iframe
export const isInIframe = () => {
	try {
		return window.self !== window.top;
	} catch (e) {
		// If we can't access window.top due to cross-origin restrictions,
		// we're definitely in an iframe
		return true;
	}
};

// auto-login with SSO
export const shouldAutoLogin = () => get("auto_login") === "1";
export const setAutoLogin = () =>
	set("auto_login", "1", {
		expires: 365, // 1 year
		path: "/",
		sameSite: "None",
		secure: true,
	});
export const clearAutoLogin = () =>
	remove("auto_login", {
		path: "/",
		sameSite: "None",
		secure: true,
	});

export const migrateAutoLoginCookies = () => {
	try {
		// remove old skip_auto_login cookie
		// default is now to NOT auto-redirect
		if (get("skip_auto_login") === "1") {
			remove("skip_auto_login", { path: "/" });
		}
	} catch (e) {
		// ignore cookie errors
		console.warn("Auto-login cookie migration failed:", e);
	}
};

export default {
	get,
	set,
	remove,
	isInIframe,
	shouldAutoLogin,
	setAutoLogin,
	clearAutoLogin,
	migrateAutoLoginCookies,
};
